'use strict';

var avatar = require('../../../../../../../../../../_virtual/avatar.cjs');

(function (exports) {

	exports.AVATAR_SIZES = void 0;
	(function(AVATAR_SIZES) {
	    AVATAR_SIZES["xsmall"] = "xsmall";
	    AVATAR_SIZES["small"] = "small";
	    AVATAR_SIZES["medium"] = "medium";
	    AVATAR_SIZES["large"] = "large";
	    AVATAR_SIZES["xlarge"] = "xlarge";
	})(exports.AVATAR_SIZES || (exports.AVATAR_SIZES = {}));
	const AVATAR_DIMENSIONS = {
	    xsmall: {
	        width: 40,
	        height: 40
	    },
	    small: {
	        width: 56,
	        height: 56
	    },
	    medium: {
	        width: 80,
	        height: 80
	    },
	    large: {
	        width: 120,
	        height: 120
	    },
	    xlarge: {
	        width: 160,
	        height: 160
	    }
	};

	exports.AVATAR_DIMENSIONS = AVATAR_DIMENSIONS;
	
} (avatar.__exports));
//# sourceMappingURL=avatar.cjs.map
